import React from 'react';
import { HardDriveIcon } from 'lucide-react';
export function Hero() {
  return <section className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/ksoxBibhMJCYNCkv5yYyLF/GlobalFileSystemHero.png')"
  }} data-id="element-508">
      <div className="absolute inset-0 bg-gradient-to-b from-header/40 via-primary/30 to-primary/50" data-id="element-509"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-510">
        <div className="text-center" data-id="element-511">
          <div className="w-16 h-16 bg-white/10 border border-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6 load-fade-in-up stagger-1" data-id="element-512">
            <HardDriveIcon className="w-8 h-8 text-white" data-id="element-513" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-2" data-id="element-514">
            Global File System Implementation
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-3" data-id="element-515">
            Distributed file system solutions for organizations requiring
            synchronized access across multiple servers and locations. We
            implement and configure GFS and similar technologies for
            high-availability storage.
          </p>
        </div>
      </div>
    </section>;
}